module.exports = __webpack_public_path__ + "img/1a2NJCV514t13ItKGPApbgiBUl8kECwt8.f1f16f16.png";